import axios from 'axios'

export const authService = {
  login
}

function login (email, password) {
  return axios.post(process.env.VUE_APP_API_URL + '/Auth', { email, password })
}
